import React from "react";
import styled from "styled-components";
import Box from "../../UI/Layout/Box";
import Item from "../../UI/Item/Item";

class Sidepanel extends React.Component {
  render() {
    return (
      <Component width="400px" floating={this.props.floating}>
        {this.props.children}
      </Component>
    );
  }
}

const Component = styled(Box)`
  position: ${props => (props.floating ? "fixed" : "")};
  top: ${props => (props.floating ? "50px" : "")};
  right: ${props => (props.floating ? "0" : "")};
  bottom: ${props => (props.floating ? "0" : "")};
  background: white;
  height: calc(100vh - 50px);
  padding: 16px;
  overflow-y: auto;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px -1px,
    rgba(0, 0, 0, 0.06) 0px 4px 5px 0px, rgba(0, 0, 0, 0.08) 0px 1px 10px 0px;
  animation: ${props => (props.floating ? "sidepanel 225ms" : "")};

  @keyframes sidepanel {
    0% {
      right: -400px;
    }
    100% {
      right: 0;
    }
  }

  dt {
    font-weight: 300;
    font-style: normal;
    font-family: "Roboto Slab", "Georgia", serif;
    letter-spacing: 0;
  }
  dl {
    font-size: inherit;
  }

  ul {
    padding-left: 0;
    list-style: none;
  }
`;

export default Sidepanel;



// WEBPACK FOOTER //
// ./src/UI/Sidepanel/Sidepanel.js